import { PortableTextBlock, stegaClean } from 'next-sanity'

import PortableTextMinimal from '@/app/components/PortableTextMinimal'
import { TRACKING_LOCATIONS } from '@/app/utils/analytics'
import { cn } from '@/app/utils/style'
import { GetPageQueryResult, HomeQueryResult } from '@/sanity.types'

type PageHeadingProps = {
  page: GetPageQueryResult | HomeQueryResult
}

export function PageHeading({ page }: PageHeadingProps) {
  if (!page || page._type === 'home') {
    return null
  }

  const { heading, overline } = page
  const headingSection = stegaClean(page.headingSection)

  if (headingSection === 'none' || !headingSection || !heading) {
    return null
  }

  const alignmentClass = headingSection === 'center' ? 'text-center' : 'text-left'

  return (
    <div className="content-container mt-8xl md:mt-11xl">
      <div className="max-w-[1120px] mx-auto">
        <div className={cn('flex flex-col gap-sm', alignmentClass)}>
          <h1 className="size-header-h4 font-normal md:size-header-h2 md:font-normal">
            <PortableTextMinimal
              value={heading as PortableTextBlock[]}
              tracking={{ location: TRACKING_LOCATIONS.PAGE_CONTENT }}
            />
          </h1>
          {overline && <p className="size-body-md md:size-body-xl text-white-800">{overline}</p>}
        </div>
      </div>
    </div>
  )
}
